import { apolloClient } from "@crispico/foundation-react";
import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { GET_FOA_IDS_FOR_FLIGHT } from "../queries";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { ShareLinkLogic } from "@crispico/foundation-react/entity_crud/ShareLinkLogic";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { AbstractAction } from "components/ContextMenuRegistry";

export class FlightOpenFlightAndObjectActionListAction extends AbstractAction {

    icon = this.getIcon();
    label = _msg("FlightAndObjectAction.openRules.label");

    protected getIcon() {
        let defaultIcon = entityDescriptors["FlightAndObjectAction"].icon as unknown as JSX.Element;
        return <defaultIcon.type key={defaultIcon.key} {...defaultIcon.props} className="AbstractAction_iconGroup" />
    }

    isVisible(param: IActionParam) {
        if (param.selection.length === 0) {
            return false;
        }
        const entityName = this.getEntityName(param.selection[0]);
        return entityName === "Flight" || entityName === "Task";
    }

    protected getFlightId(param: IActionParamForRun) {
        const key = param.selection[0];
        const entity = this.props.getEntityAt(key);
        return this.getEntityName(key) === "Flight" ? entity?.id : entity?.taskGroup.id;
    }

    async run(param: IActionParamForRun) {
        let ids = (await apolloClient.query({
            query: GET_FOA_IDS_FOR_FLIGHT,
            variables: { id: this.getFlightId(param) },
        })).data["flightAndObjectActionService_flightAndObjectActionIds"];

        AppMetaTempGlobals.history.push(new ShareLinkLogic().createLink(false, entityDescriptors["FlightAndObjectAction"],
            Filter.enableAllFilters(Filter.createComposed(FilterOperators.forComposedFilter.and,
                [Filter.create("id", FilterOperators.forNumber.in, ids.join(","))])
            )));
    }

}